import { useEffect, useState } from "react"
import ProcessoService from "../../../../services/ProcessoService"
import { Autocomplete } from "@material-ui/lab"
import { CircularProgress, TextField } from "@material-ui/core"

export default function PesquisaProcessual({ value, setValue, error, disabled }) {
    const [open, setOpen] = useState(false)
    const [options, setOptions] = useState([])
    const [pesquisaProcesso, setPesquisaProcesso] = useState(false)

    const loading = open && pesquisaProcesso

    const PesquisaProcessual = async (codigoProcesso) => {
        setPesquisaProcesso(true);
        ProcessoService.PesquisaProcessualDoSetor(codigoProcesso, false)
            .then(response => {
                setOptions(response.data)
                setPesquisaProcesso(false);
            })
            .catch(() => {
                setOptions([])
                setPesquisaProcesso(false);
            })
    }

    useEffect(() => {
        if (!loading) {
            return undefined
        }
    }, [loading])

    useEffect(() => {
        if (!open) {
            setOptions([])
        }
    }, [open])

    return (
        <Autocomplete
            multiple
            open={open}
            onOpen={() => {
                setOpen(true)
            }}
            onClose={() => {
                setOpen(false)
            }}
            value={value}
            onChange={(event, newValue) => {
                const itensSelecionados = [];

                newValue.reduce((novoItem, itemAtual) => {
                    if (novoItem.indexOf(itemAtual.autuacaoId) === -1) {
                        novoItem.push(itemAtual.autuacaoId);
                        itensSelecionados.push(itemAtual);
                    }

                    return novoItem;
                }, []);

                setOptions([]);
                setValue(itensSelecionados);
            }}
            getOptionLabel={(option) => option.descricao}
            options={options}
            loading={loading}
            loadingText="Carregando dados..."
            noOptionsText="Nenhum resultado encontrado"
            renderInput={(params) => (
                <TextField
                    {...params}
                    label="Processos"
                    variant="outlined"
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                                {loading ? <CircularProgress style={{ color: 'var(--primary)' }} size={20} /> : null}
                                {params.InputProps.endAdornment}
                            </>
                        ),
                    }}
                    onChange={event => PesquisaProcessual(event.target.value)}
                    error={error ? error.errorState : false}
                    helperText={error ? error.errorHelperText : ""}
                    placeholder="Digite o número do processo"
                    InputLabelProps={{
                        shrink: true,
                    }}
                    type="number"
                />
            )}
            disabled={disabled}
        />
    )
}